<app-modal-wrapper
  title="Select Vessel"
  [showFooter]="false"
  (closeRequest)="closeModal()"
>
  <div class="flex flex-col gap-5 h-[450px]">
    <div class="relative w-full group">
      <i
        class="pi pi-search absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-[var(--primary-500)] transition-colors z-10"
      ></i>
      <input
        pInputText
        type="text"
        [(ngModel)]="filter"
        (input)="onSearchChange()"
        placeholder="Search by name or IMO..."
        class="w-full pl-6 pr-10 py-2 text-sm border-gray-200 rounded-lg focus:ring-0 transition-all bg-gray-50 hover:bg-gray-100 focus:bg-white"
        style="box-shadow: none !important; border-radius: 8px !important"
      />
    </div>

    <app-table
      [data]="vessels"
      [columns]="tableColumns"
      [actions]="tableActions"
      [totalRecords]="totalItems"
      [loading]="loading"
      [rows]="10"
      [scrollable]="true"
      [directAction]="true"
      (onLazyLoad)="loadVesselsLazy($event)"
    >
    </app-table>
  </div>
</app-modal-wrapper>
